/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionRegionWithProviderRegions } from './subscriptionRegionWithProviderRegions';


export interface SubscriptionRegionsResponseSpec { 
    /**
     * List of subscription regions with catered provider regions.
     */
    subscription_regions?: Array<SubscriptionRegionWithProviderRegions>;
    /**
     * scubscription view/create url.
     */
    subscription_url?: string;
}

